import { AxiosResponse } from "axios";
import { ReportChecklist } from "../models/report.checklist";
import { ReportGroup } from "../models/reports.groups";
import BaseService from "./_base.service";

import API from "../api";
import APIBLOB from "../api/indexBlob";
import { Shipment } from "../models/shipments";

const endpoint = "reports/shipments";
interface ReportShipmentsResponse {
  shipments: Shipment[];
  grid?: Shipment[];
  total: number;
}
export const ReportsShipmentsService = {
  ...BaseService<ReportGroup>({ endpoint }),
  async getAll(reportType: string, options?: any): Promise<AxiosResponse<ReportShipmentsResponse>> {
    return await API.get(`/reports/shipment${reportType ? `/${reportType}` : "s"}/filter`, {
      params: options,
    });
  },
  async getSuggestions(
    options?: any,
    reportType?: string
  ): Promise<AxiosResponse<ReportChecklist[]>> {
    return await API.get(`/reports/shipment${reportType ? `/${reportType}` : "s"}/suggest`, {
      params: options,
    });
  },

  async generatePdf(options?: any): Promise<any> {
    return await APIBLOB.get(`/reports/shipment/crossdock/pdf`, {
      params: options,
      timeout: 0,
      responseType: "blob",
      headers: {
        Accept: "application/pdf",
      },
    });
  },

  async getCrossDock(options?: any): Promise<any> {
    return await API.get(`/container/conference/related`, {
      params: options,
    });
  },
};
